'use client'

import { toast as sonnerToast } from 'sonner'

type DurationCarrier = { duration?: number }

const normalizeDuration = <T extends DurationCarrier | undefined>(data: T): T => {
  if (data && data.duration === 0) {
    return { ...data, duration: Infinity } as T
  }
  return data
}

const toast = ((message, data) =>
  sonnerToast(message, normalizeDuration(data))) as typeof sonnerToast

toast.success = (message, data) => sonnerToast.success(message, normalizeDuration(data))
toast.info = (message, data) => sonnerToast.info(message, normalizeDuration(data))
toast.warning = (message, data) => sonnerToast.warning(message, normalizeDuration(data))
toast.error = (message, data) => sonnerToast.error(message, normalizeDuration(data))
toast.custom = (jsx, data) => sonnerToast.custom(jsx, normalizeDuration(data))
toast.message = (message, data) => sonnerToast.message(message, normalizeDuration(data))
toast.loading = (message, data) => sonnerToast.loading(message, normalizeDuration(data))
toast.promise = (promise, data) => sonnerToast.promise(promise, normalizeDuration(data))
toast.dismiss = (id) => sonnerToast.dismiss(id)
toast.getHistory = () => sonnerToast.getHistory()
toast.getToasts = () => sonnerToast.getToasts()

export { toast }
